export enum SchedulerField {
    SchedulerId = "scheduler_id",
    SchedulerTypeId = "scheduler_type_id",
    OrderId = "order_id",
    EmployeeId = "employee_id",
    ContactId = "contact_id",
    VehicleId = "vehicle_id",
    StartDate = "start_date",
    EndDate = "end_date",
    StartMilometer = "start_milometer",
    EndMilometer = "end_milometer",
    ExtraCosts = "extra_costs",
    Note = "note"
}

export interface ISchedulerDto {
    [SchedulerField.SchedulerId]?: string;
    [SchedulerField.SchedulerTypeId]?: string;
    [SchedulerField.OrderId]?: string;
    [SchedulerField.EmployeeId]?: string;
    [SchedulerField.ContactId]?: string;
    [SchedulerField.VehicleId]?: string;
    [SchedulerField.StartDate]?: string;
    [SchedulerField.EndDate]?: string;
    [SchedulerField.StartMilometer]?: number;
    [SchedulerField.EndMilometer]?: number;
    [SchedulerField.ExtraCosts]?: number;
    [SchedulerField.Note]?: string;
    [key: string]: any;
}

export interface ISchedulerResponse {
    currentPage: number;
    data: ISchedulerDto[];
    maxPages: number;
    nextpage: boolean;
}

export interface ISchedulerTypeDto {
    scheduler_type_id?: string;
    description?: string;
    is_show?: number | boolean;
    [key: string]: any;
}
